import {MenuGroup} from '@cindedi/ui/components/MenuGroup';
import {Card} from '@cindedi/ui/components/Card';
import {MenuItem} from '@cindedi/ui/components/MenuItem';
import {PublicMobileMenuTrigger} from '../PublicMobileMenuTrigger';
import {useRouteLoaderData} from '@remix-run/react';
import type {RootPublicLoaderData} from '~/routes/_public+/_layout';

export function PublicMenu() {
  const data = useRouteLoaderData('routes/_public+/_layout') as RootPublicLoaderData | undefined;
  const menu = data?.menu ?? [];

  return (
    <Card className="flex flex-col gap-4 p-4 relative" shadow md:shadow={false}>
      <div className="lg:hidden absolute right-0 top-0 m-2">
        <PublicMobileMenuTrigger />
      </div>
      {menu.map((group) => (
        <MenuGroup key={group.id} title={group.title} aria-label={group.title}>
          {group.items.map((item) => (
            <MenuItem key={item.id} href={item.href}>
              {item.label}
            </MenuItem>
          ))}
        </MenuGroup>
      ))}
    </Card>
  );
}
